<script>
    import { Route } from 'svelte-router-spa';
    export let currentRoute, params = {};
	import { onMount } from 'svelte';
    import { fade } from 'svelte/transition';

    import Header from './lib/Header.svelte';
    import Footer from './lib/Footer.svelte';
</script>
<div id="app" class="flex flex-col items-center justify-center h-screen max-h-screen overflow-hidden">
    <Header {currentRoute}></Header>

    <Route {currentRoute} {params}/>

    <!-- <Footer></Footer> -->
</div>